

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';

import { MwcSafeAny } from 'mwc/core/types';

@Component({
  selector: 'mwc-select-clear',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      mwc-icon
      mwcType="close-circle"
      mwcTheme="fill"
      *ngIf="!clearIcon; else clearIcon"
      class="mwc-select-close-icon"
    ></span>
  `,
  host: {
    class: 'mwc-select-clear',
    '(click)': 'onClick($event)'
  }
})
export class MwcSelectClearComponent {
  @Input() clearIcon: TemplateRef<MwcSafeAny> | null = null;
  @Output() readonly clear = new EventEmitter<MouseEvent>();

  constructor() {}

  onClick(e: MouseEvent): void {
    e.preventDefault();
    e.stopPropagation();
    this.clear.emit(e);
  }
}
